import { findLocalizableField } from "./scheme-localizable";
import { readLocalized, setLocalized } from "./i18n";
export function acceptedText(field) {
    var _a;
    const edited = (_a = field.edited) === null || _a === void 0 ? void 0 : _a.trim();
    return edited && edited.length > 0 ? edited : field.value;
}
export function isSourced(field) {
    return field.evidence != null && field.evidence.quote.trim().length > 0;
}
export function bulkAcceptable(fields) {
    return fields.filter((f) => f.decision === "pending" && isSourced(f));
}
export function unsourcedPending(fields) {
    return fields.filter((f) => f.decision === "pending" && !isSourced(f));
}
export function proposalCounts(fields) {
    return {
        total: fields.length,
        pending: fields.filter((f) => f.decision === "pending").length,
        accepted: fields.filter((f) => f.decision === "accepted").length,
        rejected: fields.filter((f) => f.decision === "rejected").length,
        unsourced: unsourcedPending(fields).length,
        edited: fields.filter((f) => f.decision === "accepted" && acceptedText(f) !== f.value).length,
    };
}
export function decideField(fields, id, decision, edited) {
    return fields.map((f) => {
        if (f.id !== id)
            return f;
        const next = { ...f, decision };
        if (edited === undefined)
            return next;
        const trimmed = edited.trim();
        if (trimmed.length === 0 || trimmed === f.value)
            delete next.edited;
        else
            next.edited = edited;
        return next;
    });
}
export function acceptAllSourced(fields) {
    const ids = new Set(bulkAcceptable(fields).map((f) => f.id));
    return fields.map((f) => ids.has(f.id) ? { ...f, decision: "accepted" } : f);
}
export function applyAccepted(content, fields, defaultLocale) {
    let next = content;
    const applied = [];
    const skipped = [];
    for (const field of fields) {
        if (field.decision !== "accepted")
            continue;
        const descriptor = findLocalizableField(next, field.fieldId);
        if (!descriptor) {
            skipped.push({ field, reason: "field_gone", actual: "" });
            continue;
        }
        const stored = descriptor.read(next);
        const actual = typeof stored === "string"
            ? field.locale === defaultLocale
                ? stored
                : ""
            : readLocalized(stored, field.locale);
        if (actual !== field.current) {
            skipped.push({ field, reason: "changed_since_generated", actual });
            continue;
        }
        next = descriptor.write(next, setLocalized(stored, field.locale, defaultLocale, acceptedText(field)));
        applied.push(field.id);
    }
    return { content: next, applied, skipped };
}
